// extracted by mini-css-extract-plugin
export default {"userMenuMenuItem":"UserMenu_userMenuMenuItem__NpMvs","userMenuPopover":"UserMenu_userMenuPopover__Y5fmB"};